import { trackButtonClicked } from '@/lib/analytics/scribe/button';
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import type { InSessionRoutineButtonLabel } from '@heidi/agents/contracts';
import { ButtonAction, ScreenName } from '@heidi/runtime/analytics-vocabulary';

export type { InSessionRoutineButtonLabel } from '@heidi/agents/contracts';

export function trackInSessionRoutinesViewed(): void {
  track({
    event_name: TrackingEventName.ScreenViewed,
    props: { screen_name: ScreenName.Heidi2InSessionRoutines },
    options: { amplitude: false, snowplow: true },
  });
}

export function trackInSessionRoutineButtonClicked(
  label: InSessionRoutineButtonLabel,
  sessionId: string
): void {
  trackButtonClicked({
    screen_name: ScreenName.Heidi2InSessionRoutines,
    action: ButtonAction.Heidi2InSessionRoutines,
    label,
    session_id: sessionId,
  });
}
